// extracted by mini-css-extract-plugin
module.exports = {"layout":"ArticlePage_layout__Hmlbz","breadcrumbs":"ArticlePage_breadcrumbs__Wc2mp"};